import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {PngoDealershipService} from "../../utils/data-services/pngo-dealership.service";

@Component({
  selector: 'app-update-pngo-dealership',
  templateUrl: './update-pngo-dealership.component.html',
  styleUrls: ['./update-pngo-dealership.component.scss']
})
export class UpdatePngoDealershipComponent implements OnInit {
  dealershipId = 0;
  dealershipInformations: {
    dealership_id: number,
    name: string,
    external_group_id: string,
    external_branch_id: string,
    active: boolean,
    opening_time: string,
    closing_time: string,
    lunch_break_start: string,
    lunch_break_end: string,
    uniqid: string,
    dealership_temp: boolean,
    open_on_saturday: boolean
  };
  constructor(private activeRoute: ActivatedRoute, private route: Router, private dataService: PngoDealershipService) { }

  ngOnInit() {
    this.dealershipId = Number(this.activeRoute.snapshot.paramMap.get('dealershipId'));
    this.getDealershipInformations();
  }
  getDealershipInformations(): void {
    this.dataService.getDealershipInformations(this.dealershipId).subscribe(result => {
      this.dealershipInformations = result;
    });
  }
  updateDealershipInformations(): void {
    if (this.dealershipInformations.lunch_break_start.split(':').length < 3) {
      this.dealershipInformations.lunch_break_start = this.dealershipInformations.lunch_break_start + ':00';
    }
    if (this.dealershipInformations.lunch_break_end.split(':').length < 3) {
      this.dealershipInformations.lunch_break_end = this.dealershipInformations.lunch_break_end + ':00';
    }
    if (this.dealershipInformations.opening_time.split(':').length < 3) {
      this.dealershipInformations.opening_time = this.dealershipInformations.opening_time + ':00';
    }
    if (this.dealershipInformations.closing_time.split(':').length < 3) {
      this.dealershipInformations.closing_time = this.dealershipInformations.closing_time + ':00';
    }
    this.dataService.updateDealershipInformations(this.dealershipInformations).subscribe(result => {
      this.route.navigate(['../gestion-mapping-planngo']);
    });
  }
  onCancelClick(): void {
    this.route.navigate(['../gestion-mapping-planngo']);
  }
  changeBoolValue(value: string): void {
    this.dealershipInformations[value] = !this.dealershipInformations[value];
  }
}
